import { useCallback } from 'react'

export type DownloadFileFn = (
  content: string,
  fileName?: string,
  extension?: string,
) => void

const normalizeExtension = (ext: string) => {
  const trimmed = ext.trim()
  if (!trimmed) return ''
  return trimmed.startsWith('.') ? trimmed : `.${trimmed}`
}

const guessMimeType = (normalizedExt: string) => {
  if (normalizedExt.toLowerCase() === '.json')
    return 'application/json;charset=utf-8'
  return 'text/plain;charset=utf-8'
}

export const useDownloadFile = (): DownloadFileFn => {
  return useCallback((content, fileName = 'file', extension = 'json') => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return

    const ext = normalizeExtension(extension)
    const finalName = `${fileName}${ext}`
    const mime = guessMimeType(ext)

    const blob = new Blob([content], { type: mime })
    const url = URL.createObjectURL(blob)

    const a = document.createElement('a')
    a.href = url
    a.download = finalName
    a.style.display = 'none'

    document.body.appendChild(a)
    a.click()
    a.remove()

    URL.revokeObjectURL(url)
  }, [])
}
